export enum ObjectMode {
  Open = 'Open',
  Planned = 'Planned',
  Completed = 'Completed',
  Closed = 'Closed'
}
